import { render, staticRenderFns } from "./AutomaticRemittanceConfirm.vue?vue&type=template&id=25c83470&scoped=true&"
import script from "./AutomaticRemittanceConfirm.vue?vue&type=script&lang=js&"
export * from "./AutomaticRemittanceConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticRemittanceConfirm.vue?vue&type=style&index=0&id=25c83470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c83470",
  null
  
)

export default component.exports